import React, { useEffect, useState } from "react";
import { Alert, Container, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

export default function RestFurnizori() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      setErr("");
      setBusy(true);
      try {
        const data = await authFetch("/intrare/rest/sumar?eps=0.01&limit=200");

        setItems(data || []);
      } catch (e) {
        setErr(String(e?.message || e));
      } finally {
        setBusy(false);
      }
    })();
  }, []);

  const totalGeneral = items.reduce(
    (acc, x) => acc + (Number(x.total_sold) || 0),
    0,
  );

  return (
    <Container className="py-3">
      <h3>Furnizori neplătiți</h3>

      {err ? <Alert variant="danger">{err}</Alert> : null}
      {busy ? <div className="text-muted">Se încarcă...</div> : null}

      <Table bordered size="sm" className="align-middle mt-2">
        <thead>
          <tr>
            <th>Furnizor</th>
            <th style={{ width: 120 }} className="text-end">
              Facturi
            </th>
            <th style={{ width: 160 }} className="text-end">
              Rest
            </th>
          </tr>
        </thead>

        <tbody>
          {items.map((x) => (
            <tr key={x.contact_id}>
              <td>{x.contact_name}</td>
              <td className="text-end">{x.count_docs}</td>
              <td className="text-end">
                {Number(x.total_sold || 0).toFixed(2)}
              </td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          <tr>
            <td className="fw-semibold text-end">TOTAL</td>
            <td className="text-end fw-semibold">
              {items.reduce((a, x) => a + (x.count_docs || 0), 0)}
            </td>
            <td className="text-end fw-semibold">{totalGeneral.toFixed(2)}</td>
          </tr>
        </tfoot>
      </Table>
    </Container>
  );
}
